import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { showError, showSuccess } from "../lib/toast";
import { useAuth } from "../context/AuthContext";

const GoogleCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState("Verifying...");

  useEffect(() => {
    // Check for token directly in URL (from successful Google redirect)
    const token = searchParams.get("token");
    const userJson = searchParams.get("user");
    const error = searchParams.get("error");

    if (error) {
      setStatus("Error: " + error);
      showError("Google login failed: " + error);
      setTimeout(() => navigate("/login"), 2000);
      return;
    }

    if (token && userJson) {
      try {
        let parsed = JSON.parse(decodeURIComponent(userJson));
        // Fallback: handle double-encoded JSON
        if (typeof parsed === 'string') {
          try {
            parsed = JSON.parse(parsed);
          } catch {
            // Not double-encoded
          }
        }
        const user = parsed;
        localStorage.setItem("accessToken", token);
        localStorage.setItem("user", JSON.stringify(user));
        setUser(user);
        // showSuccess("Login successful!");
        
        switch (user.role) {
          case "admin":
            navigate("/dashboard/admin", { replace: true });
            break;
          case "instructor":
            navigate("/dashboard/instructor", { replace: true });
            break;
          case "mentor":
            navigate("/dashboard/mentor", { replace: true });
            break;
          default:
            navigate("/dashboard/student", { replace: true });
        }
        return;
      } catch (e: any) {
        console.error("Parse error:", e.message);
        console.error("Raw userJson:", userJson ? userJson.substring(0, 500) : "null");
        showError("Failed to parse user data");
        setStatus("Error parsing user data: " + (e.message || "unknown"));
        if (setUser && !user) {
          // Set minimal user from token if available
          const stored = localStorage.getItem("user");
          if (stored) {
            try {
              const storedUser = JSON.parse(stored);
              setUser(storedUser);
              const redirectRole = storedUser.role || "student";
              setTimeout(() => navigate(`/dashboard/${redirectRole}`, { replace: true }), 1000);
              return;
            } catch {}
          }
        }
        setTimeout(() => navigate("/login"), 3000);
      }
    } else {
      // No token - redirect to login (something went wrong)
      showError("Google login failed: No token received");
      setStatus("No token received");
      setTimeout(() => navigate("/login"), 2000);
    }
  }, [searchParams, navigate, setUser]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <GraduationCap className="w-8 h-8 text-orange-600 animate-pulse" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Connecting your account</h2>
        <p className="text-gray-500">{status}</p>
      </div>
    </div>
  );
};

export default GoogleCallbackPage;